const state = {
  leaguePanel: true,
  fullSizePage: false
}

// mutations are operations that actually mutates the state.
// each mutation handler gets the entire state tree as the
// first argument, followed by additional payload arguments.
// mutations must be synchronous and can be recorded by plugins
// for debugging purposes.
const mutations = {
  modifyLeaguePanel (state, newState) {
    state.leaguePanel = newState
  },
  modifyfullSizePage (state, newState) {
    state.fullSizePage = newState
  }
}

// actions are functions that causes side effects and can involve
// asynchronous operations.
const actions = {
  showLeaguePanel (context) {
    context.commit('modifyLeaguePanel', true)
  },
  hideLeaguePanel (context) {
    context.commit('modifyLeaguePanel', false)
  },
  activateFullSizePage (context) {
    context.commit('modifyfullSizePage', true)
  },
  deactivateFullSizePage (context) {
    context.commit('modifyfullSizePage', false)
  }
}
// getters are functions
const getters = {
  showLeaguePanel: state => {
    return state.leaguePanel
  },
  isFullSizePage: state => {
    return state.fullSizePage
  }
}

export default {
  state,
  getters,
  actions,
  mutations
}




// WEBPACK FOOTER //
// ./src/store/hmi.js